import { LinearProgress } from '@mui/material'
import { ArrowDropUp } from '@mui/icons-material'
import styles from './ProgressBarWindow.module.scss'

export default function ProgressBarWindow({precent, tag, secondTag}){
    const leftKey = Object.keys(tag)[0]
    const rightKey = Object.keys(secondTag)[0]
    return(
        <div className={styles['progressbar-window']}>
            <div>
                <div className={styles['progressbar-tags']}>
                    <div>
                        <p>{leftKey}</p>
                        <p>{tag[leftKey]}</p>
                    </div>
                    <div>
                        <p>{rightKey}</p>
                        <p>{secondTag[rightKey]}</p>
                    </div>
                </div>
                <LinearProgress classes={{ colorPrimary: styles['colorPrimary'], barColorPrimary: styles['barColorPrimary'] }} value={precent} variant="determinate"/>
                <div style={{paddingLeft:`calc(${precent}% - 12px)`, display:'flex'}}>
                    <ArrowDropUp/>
                </div>
            </div>
        </div>
    )
}